import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { loadGroupsForUser } from "../../redux/actions/groupActions";
import Spinner from "../common/Spinner";
import './Group.css';


function UserGroupsView({
    user,
    loadGroupsForUser,
    subjectUser
}) {

    const [subjectUserGroups, setSubjectUserGroups] = useState({});
    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        loadGroupsForUser(subjectUser.id)
            .then((groups) => {
                setSubjectUserGroups(groups);
                setProcessing(false)
            })
    }, [])

    function getGroupTypeBadge(type) {
        switch (type) {
            case "Public":
                return "fas fa-lock-open";
            case "PublicClosed":
                return "fas fa-lock";
            case "Private":
                return "fas fa-eye-slash";
            default:
                return "fas fa-question";
        }
    }

    return (
        <div className="group-search col-12">
            <div className="search-toolbar top-form"></div>
            { processing ?
                <Spinner /> :
                <div className="group-results">
                    {subjectUserGroups.groups.length == 0 ?
                        <div className="empty-message">
                            <span className="fas fa-users empty-icon"></span>
                            <div className="empty-text">{`${subjectUser.firstName} is not a member of any groups.`}</div>
                        </div>
                        :
                        <React.Fragment>
                            <div className="group-results-header">{`${subjectUser.firstName}'s Groups`}</div>
                            <ul className="mt-3">
                                {
                                    subjectUserGroups.groups.map((group, index) => {
                                        return (
                                            <li className="group-link" key={group.id}>
                                                <Link to={`/groups/${group.friendlyUrl ? group.friendlyUrl : group.id}`} >
                                                    {
                                                        group.avatarAvailable ?
                                                            <UserAvatar className="group-avatar-default" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                            :
                                                            <div className="group-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    <div className={`group-badge ${group.access.toLowerCase()}`}><span className={getGroupTypeBadge(group.access)}></span></div>
                                                    <div>{group.name}</div>
                                                </Link>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </React.Fragment>
                    }
                </div>
            }
        </div>
    );
};

UserGroupsView.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUserId: PropTypes.object,
    loadGroupsForUser: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    loadGroupsForUser
}

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsView);


// WEBPACK FOOTER //
// ./src/components/groups/UserGroupsView.js